import removeMarkdown from 'markdown-to-text';
import { marked } from 'marked';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
declare const PlainTextRenderer: any;

const mdOptions = {
    // whether to conform to original MD implementation
    pedantic: false,
    // Github Flavoured Markdown
    gfm: true,
    // tables extension
    tables: true,
    // smarter list behavior
    smartLists: true,
    // "smart" typographic punctuation for things like quotes and dashes
    smartypants: true,
    // sanitize HTML tags
    sanitize: true,
    // ... other options
};

const todoListItemRenderer = (text: string) => {
    if (text.includes('type="checkbox"')) {
        return `<li style="list-style: none">${text}</li>`;
    }

    return `<li>${text}</li>`;
};

const externalLinkRenderer = (href: string, title: string, text: string) => {
    if (href.startsWith('http://') || href.startsWith('https://')) {
        if (!text) {
            text = href;
        }

        return `<a target="_blank" href="${href}" title="${title}">${text}</a>`;
    }

    return `[${text}](${href})`;
};

export const convertToHTML = (markdownText: string) => {
    const renderer = new marked.Renderer();
    renderer.listitem = todoListItemRenderer;
    renderer.link = externalLinkRenderer;
    marked.setOptions(mdOptions);

    return marked(markdownText, { renderer });
};

export const convertToPlainText = (markdownText: string) => removeMarkdown(markdownText);
